export default __webpack_public_path__ + "static/accessibility-92164f76197348be7b7e1090307a40b0.png";